import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [isMobile, setMobile] = useState(window.innerWidth < 599);

  const updateMedia = () => {
    setMobile(window.innerWidth < 599);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);
  return isMobile;
};

export default useIsMobile;
